import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/inspiration-task-manage',
    name: 'InspirationTaskManage',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/inspiration-task-manage/fm-task-manage/list',
    meta: {
      title: '灵感任务管理'
    },
    children: [
      {
        path: 'fm-task-manage/list',
        name: 'InspirationTaskManageFmTaskManageList',
        component: () => import('./fm-task-manage/views/list/index.vue'),
        meta: {
          title: 'FM任务管理',
          auth: true,
        },
      },
      {
        path: 'fm-task-manage/detail/:taskCode',
        name: 'InspirationTaskManageFmTaskManageDetail',
        component: () => import('./fm-task-manage/views/detail/index.vue'),
        meta: {
          title: 'FM任务管理详情',
          auth: true,
        },
      },
      {
        path: 'fm-task-manage/batch-detail/:taskCode',
        name: 'InspirationTaskManageFmTaskManageBatchDetail',
        component: () => import('./fm-task-manage/views/batch-detail/index.vue'),
        meta: {
          title: 'FM任务管理详情',
          auth: true,
        },
      },
      {
        path: 'fm-task-manage/style-derive-detail/:taskCode',
        name: 'InspirationTaskManageFmTaskManageStyleDeriveDetail',
        component: () => import('./fm-task-manage/views/style-derive-detail/index.vue'),
        meta: {
          title: 'FM任务管理详情',
          auth: true,
        },
      },
      {
        path: 'smart-plan-manage/list',
        name: 'InspirationTaskManageSmartPlanManageList',
        component: () => import('./smart-plan-manage/views/list/index.vue'),
        meta: {
          title: '智能企划列表',
          auth: true,
        },
      },
      {
        path: 'plan-statistics/list',
        name: 'InspirationTaskManagePlanStatisticsList',
        component: () => import('./plan-statistics/views/list/index.vue'),
        meta: {
          title: '智能企划统计',
          auth: true,
        },
      },
      {
        path: 'style-plan-statistics/list',
        name: 'InspirationTaskManageStylePlanStatisticsList',
        component: () => import('./style-plan-statistics/views/list/index.vue'),
        meta: {
          title: '款式衍生统计',
          auth: true,
        },
      },
      {
        path: 'fg-task-manage/list',
        name: 'InspirationTaskManageFgTaskManageList',
        component: () => import('./fg-task-manage/views/list/index.vue'),
        meta: {
          title: 'gen任务',
          auth: true,
        },
      },
      {
        path: 'pattern-task/list',
        name: 'InspirationTaskManagePatternTaskList',
        component: () => import('./pattern-task/views/list/index.vue'),
        meta: {
          title: '服装换色列表',
          auth: true,
          activeMenu: 'InspirationTaskManagePatternTaskList',
        },
      },
      {
        path: 'pattern-task/detail/:id',
        name: 'InspirationTaskManagePatternTaskDetail',
        component: () => import('./pattern-task/views/detail/index.vue'),
        meta: {
          title: '服装换色详情',
          auth: true,
          activeMenu: 'InspirationTaskManagePatternTaskList',
        },
      },
      {
        path: 'logo-task/list',
        name: 'InspirationTaskManageLogoTaskList',
        component: () => import('./pattern-task/views/list/index.vue'),
        meta: {
          title: '图案任务列表',
          auth: true,
          activeMenu: 'InspirationTaskManageLogoTaskList',
        },
      },
      {
        path: 'logo-task/detail/:id',
        name: 'InspirationTaskManageLogoTaskDetail',
        component: () => import('./pattern-task/views/detail/index.vue'),
        meta: {
          title: '图案任务详情',
          auth: true,
          activeMenu: 'InspirationTaskManageLogoTaskList',
        },
      },
      // 图案设计任务
      {
        path: 'logo-design-task/list',
        name: 'InspirationTaskManageLogeDesignTaskList',
        component: () => import('./logo-design-task/views/list/index.vue'),
        meta: {
          title: '图案设计任务',
          auth: true,
          activeMenu: 'InspirationTaskManageLogeDesignTaskList',
        },
      },
      {
        path: 'logo-design-task/detail/:id',
        name: 'InspirationTaskManageLogoDesignTaskDetail',
        component: () => import('./logo-design-task/views/detail/index.vue'),
        meta: {
          title: '图案设计任务详情',
          auth: true,
          activeMenu: 'InspirationTaskManageLogeDesignTaskList',
        },
      },
      // 图案上传记录
      {
        path: 'logo-upload-record/list',
        name: 'InspirationTaskManageLogoUloadRecordList',
        component: () => import('./logo-upload-record/views/list/index.vue'),
        meta: {
          title: '图案上传记录',
          auth: true,
          activeMenu: 'InspirationTaskManageLogoUloadRecordList',
        },
      },
      {
        path: 'virtual-clothing/list',
        name: 'InspirationTaskManageVirtualClothingList',
        component: () => import('./virtual-clothing/views/list/index.vue'),
        meta: {
          title: '虚拟换衣任务列表',
          auth: true,
          activeMenu: 'InspirationTaskManageVirtualClothingList',
        },
      },
      {
        path: 'virtual-clothing/detail/:id',
        name: 'InspirationTaskManageVirtualClothingDetail',
        component: () => import('./virtual-clothing/views/detail/index.vue'),
        meta: {
          title: '虚拟换衣任务详情',
          auth: true,
          activeMenu: 'InspirationTaskManageVirtualClothingList',
        },
      },
      {
        path: 'flower-pattern-extract/list',
        name: 'InspirationTaskManageFlowerPatternExtractList',
        component: () => import('./flower-pattern-extract/views/list/index.vue'),
        meta: {
          title: '花型提取任务列表',
          auth: true,
          activeMenu: 'InspirationTaskManageFlowerPatternExtractList',
        },
      },
      {
        path: 'flower-pattern-extract/detail/:taskCode',
        name: 'InspirationTaskManageFlowerPatternExtractDetail',
        component: () => import('./flower-pattern-extract/views/detail/index.vue'),
        meta: {
          title: '花型提取任务详情',
          auth: true,
          activeMenu: 'InspirationTaskManageFlowerPatternExtractList',
        },
      },
      {
        path: 'ai-design-manage/list',
        name: 'InspirationTaskManageAiDesignManageList',
        component: () => import('./ai-design-manage/views/list/index.vue'),
        meta: {
          title: 'AI任务设计管理',
          activeMenu: 'InspirationTaskManageAiDesignManageList',
          auth: true,
        },
      },
      {
        path: 'ai-design-manage/detail/:taskCode',
        name: 'InspirationTaskManageAiDesignManageDetail',
        component: () => import('./ai-design-manage/views/detail/index.vue'),
        meta: {
          title: 'AI任务设计详情',
          activeMenu: 'InspirationTaskManageAiDesignManageList',
          auth: true,
        },
      },
      // 局部改款任务
      {
        path: 'partial-modify-task/list',
        name: 'InspirationTaskManagePartialModifyTaskList',
        component: () => import('./partial-modify-task/views/list/index.vue'),
        meta: {
          title: '局部改款任务',
          auth: true,
          activeMenu: 'InspirationTaskManagePartialModifyTaskList',
        },
      },
      {
        path: 'partial-modify-task/detail/:taskId',
        name: 'InspirationTaskManagePartialModifyTaskDetail',
        component: () => import('./partial-modify-task/views/detail/index.vue'),
        meta: {
          title: '局部改款任务详情',
          auth: true,
          activeMenu: 'InspirationTaskManagePartialModifyTaskList',
        },
      },
    ],
  }
] as IRouteConfig[];
